import WikiPage from "../components/Wiki/WikiPage.jsx";
import Downloads from "../components/Downloads.tsx";
import Map from "../components/Map.tsx";
import ModelCijfers from "../components/ModelCijfers.tsx";

import PrivateRoute from "../components/PrivateRoute.tsx";
const wikipagesFiles = require('./list-of-wikipages.json');


const wikipages = wikipagesFiles.wikipages

const routesConfig = [
  {
    path: '/map',
    component: () => <PrivateRoute><Map/></PrivateRoute>,
  },
  {
    path: '/wiki',
    component: () => <PrivateRoute><WikiPage menu={wikipages} title="Wiki" file={`${process.env.PUBLIC_URL}/wikipages/${wikipages[0].file}.md`} /></PrivateRoute>,
    },
  {
    path: '/downloads',
    component: () => <PrivateRoute><Downloads/></PrivateRoute>,
  },
  {
    path: '/modelcijfers',
    component: () => <PrivateRoute><ModelCijfers/></PrivateRoute>,
  },
  // Add more routes as needed
];

const wikiroutesConfig = []

wikipagesFiles.wikipages.forEach(file => {
  const routePath = `/wiki/${file.file}`;
  wikiroutesConfig.push({
    path: routePath,
    component: () => <PrivateRoute><WikiPage menu={wikipages} title={file.title} file={`${process.env.PUBLIC_URL}/wikipages/${file.file}.md`} /></PrivateRoute>,
  });
});

export async function getRoutesFromFileStructure() {
  // Simulate an async operation
  return new Promise((resolve) => {
      resolve([...routesConfig,...wikiroutesConfig]);
  });
}